import './products-choice-field.scss'

import React, { useEffect, useState } from 'react'
import { FilterChip } from '@entur/chip'
import { useOnlyUpdateableEffect } from '../../hooks/common-hooks'

type ProductInfo = {
  name: string
  isSet: boolean
}

type ProductChoiceChipProps = {
  productInfo: ProductInfo
  setProductInfo: React.Dispatch<React.SetStateAction<ProductInfo>>
}
const ProductChoiceChip: React.FC<ProductChoiceChipProps> = ({ productInfo, setProductInfo }) => {
  return (
    <FilterChip
      value={productInfo.name}
      className="product-choice_chip"
      checked={productInfo.isSet}
      onChange={() => setProductInfo({ ...productInfo, isSet: !productInfo.isSet })}
    >
      {productInfo.name}
    </FilterChip>
  )
}

type ProductsChoiceFieldProps = {
  setProductsName: (value: string) => void
  productNames: string
}
const ProductsChoiceField: React.FC<ProductsChoiceFieldProps> = ({ setProductsName, productNames }) => {
  const [silver, setSilver] = useState<ProductInfo>({
    name: 'Sølv',
    isSet: productNames.includes('Sølv'),
  })
  const [bronze, setBronze] = useState<ProductInfo>({
    name: 'Bronse',
    isSet: productNames.includes('Bronse'),
  })
  const [none, setNone] = useState<ProductInfo>({
    name: 'Ikke valgt',
    isSet: productNames.includes('Ikke valgt'),
  })

  useOnlyUpdateableEffect(() => {
    const productsName = [silver, bronze, none]
      .filter((chip) => chip.isSet)
      .map((chip) => chip.name)
      .join()
    setProductsName(productsName)
  }, [silver, bronze, none])

  // For clearing input, we dont want to do this when lables are updated, only when name string is changed
  /* eslint-disable */
  useEffect(() => {
    if (productNames === '') {
      setSilver({ ...silver, isSet: false })
      setBronze({ ...bronze, isSet: false })
      setNone({ ...none, isSet: false })
    }
  }, [productNames])
  /* eslint-enable */

  return (
    <div className="product-choice">
      <ProductChoiceChip productInfo={silver} setProductInfo={setSilver} />
      <ProductChoiceChip productInfo={bronze} setProductInfo={setBronze} />
      <ProductChoiceChip productInfo={none} setProductInfo={setNone} />
    </div>
  )
}

export default ProductsChoiceField
